import { render, staticRenderFns } from "./buyerMessage.vue?vue&type=template&id=5ab2386a&scoped=true&"
import script from "./buyerMessage.vue?vue&type=script&lang=js&"
export * from "./buyerMessage.vue?vue&type=script&lang=js&"
import style0 from "./buyerMessage.vue?vue&type=style&index=0&id=5ab2386a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab2386a",
  null
  
)

export default component.exports